var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#3176BC",
    fillOpacity: 0.05,
    stroke: "#3176BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17582_247110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.714 8.40373C18.5542 8.27293 18.3542 8.20137 18.1476 8.20117C18.0152 8.20092 17.8843 8.23024 17.7646 8.28698C17.6449 8.34372 17.5393 8.42646 17.4556 8.52917C17.3058 8.71276 17.2348 8.9483 17.2583 9.18414C17.2818 9.41998 17.3979 9.63687 17.5811 9.78725C18.2294 10.316 18.7517 10.9827 19.1099 11.7388C19.4681 12.4949 19.6532 13.3213 19.6518 14.158C19.6518 17.2759 17.1153 19.8124 13.9974 19.8124C10.8795 19.8124 8.34301 17.2759 8.34301 14.1581C8.34156 13.3215 8.52668 12.4951 8.88489 11.739C9.2431 10.9829 9.76538 10.3162 10.4137 9.78741C10.5969 9.63703 10.713 9.42016 10.7365 9.18433C10.7601 8.9485 10.6892 8.71296 10.5393 8.52933C10.4556 8.42669 10.35 8.34401 10.2303 8.28733C10.1105 8.23064 9.97964 8.20137 9.84717 8.20165C9.6408 8.20188 9.44081 8.27325 9.28093 8.40373C7.54845 9.82181 6.55469 11.9193 6.55469 14.158C6.55469 18.262 9.89341 21.6007 13.9974 21.6007C18.1014 21.6007 21.4401 18.2618 21.4401 14.158C21.4401 11.9193 20.4465 9.82197 18.714 8.40373Z",
    fill: "#3176BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9956 14.5282C14.2327 14.528 14.46 14.4337 14.6276 14.2661C14.7952 14.0985 14.8895 13.8712 14.8897 13.6342V7.29447C14.8897 6.80151 14.4888 6.40039 13.9956 6.40039C13.5025 6.40039 13.1016 6.80151 13.1016 7.29447V13.6342C13.1018 13.8712 13.1961 14.0985 13.3637 14.2661C13.5313 14.4337 13.7586 14.528 13.9956 14.5282Z",
    fill: "#3176BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17582_247110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/Activate.335b2091e291aa4bc5052d5d10f7a3a0.svg";
export { ForwardRef as ReactComponent };